import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../services/api';
import { API_URL } from '../../../config/apiUrl';
import logo from '../../../assets/logo.png';
import './styles.css';

const GerenciarCidades = () => {
  const [cidades, setCidades] = useState('');
  const [cidadesList, setCidadesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [raioCidades, setRaioCidades] = useState(15);
  const [raioGlobal, setRaioGlobal] = useState(50);
  const [filtrarAcheSeuPintor, setFiltrarAcheSeuPintor] = useState(false);
  const [priorizarCluster, setPriorizarCluster] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    carregarCidades();
    carregarConfiguracao();
  }, []);

  const carregarConfiguracao = async () => {
    try {
      setConfigLoading(true);
      const response = await api.get(API_URL.BUSCA_CONFIG.url);
      setRaioCidades(response.data.minimo);
      setRaioGlobal(response.data.maximo);
      setFiltrarAcheSeuPintor(response.data.filtrarAcheSeuPintor);
      setPriorizarCluster(response.data.priorizarCluster);
    } catch (error) {
      console.error('Erro ao carregar configuração:', error);
      setMessage('Erro ao carregar configuração da busca');
      setMessageType('error');
    } finally {
      setConfigLoading(false);
    }
  };

  const salvarConfiguracao = async (e) => {
    e.preventDefault();
    const minimo = Number(raioCidades);
    const maximo = Number(raioGlobal);

    if (
      !Number.isInteger(minimo) ||
      minimo < 1 ||
      !Number.isInteger(maximo) ||
      maximo < 1
    ) {
      setMessage('Informe raios válidos, em quilômetros');
      setMessageType('error');
      return;
    }

    try {
      setConfigLoading(true);
      setMessage('');
      const response = await api.put(API_URL.BUSCA_CONFIG_UPDATE.url, {
        minimo,
        maximo,
        filtrarAcheSeuPintor,
        priorizarCluster,
      });
      setRaioCidades(response.data.minimo);
      setRaioGlobal(response.data.maximo);
      setFiltrarAcheSeuPintor(response.data.filtrarAcheSeuPintor);
      setPriorizarCluster(response.data.priorizarCluster);
      setMessage('Configuração da busca salva com sucesso!');
      setMessageType('success');
    } catch (error) {
      console.error('Erro ao salvar configuração:', error);
      setMessage('Erro ao salvar configuração da busca');
      setMessageType('error');
    } finally {
      setConfigLoading(false);
    }
  };

  const carregarCidades = async () => {
    try {
      setLoading(true);
      const response = await api.get(API_URL.CIDADES_LIST.url);
      
      if (response.data && Array.isArray(response.data)) {
        const cidadesFormatadas = response.data.map(cidade => ({
          cidade: cidade.cidade,
          estado: cidade.estado
        }));
        setCidadesList(cidadesFormatadas);
      } else {
        setCidadesList([]);
      }
    } catch (error) {
      console.error('Erro ao carregar cidades:', error);
      setMessage('Erro ao carregar cidades');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!cidades.trim()) {
      setMessage('Digite pelo menos uma cidade');
      setMessageType('error');
      return;
    }

    try {
      setLoading(true);
      setMessage('');

      const cidadesArray = cidades
        .split(',')
        .map(cidade => cidade.trim()) 
        .filter(cidade => cidade.length > 0);

      if (cidadesArray.length === 0) {
        setMessage('Digite cidades válidas');
        setMessageType('error');
        return;
      }

      const cidadesData = cidadesArray.map(cidadeInput => {
        const match = cidadeInput.match(/^(.+?)\s*\(([A-Za-z]{2})\)$/);
        if (match) {
          return {
            cidade: match[1].trim(),
            estado: match[2].trim().toUpperCase()
          };
        } else {
          return {
            cidade: cidadeInput,
            estado: null
          };
        }
      });
      
      const response = await api.put(API_URL.CIDADES_UPDATE.url, {
        cidades: cidadesData
      });
      
      if (response.data) {
        setMessage(`${cidadesArray.length} cidade(s) salva(s) com sucesso!`);
        setMessageType('success');
        setCidades('');
        
        await carregarCidades();
      } else {
        setMessage('Erro ao salvar cidades');
        setMessageType('error');
      }
      
    } catch (error) {
      console.error('Erro ao salvar cidades:', error);
      setMessage('Erro ao salvar cidades');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    navigate('/painel');
  };

  const limparMensagem = () => {
    setMessage('');
    setMessageType('');
  };

  const removerCidade = async (cidade, estado) => {
    try {
      setLoading(true);
      setMessage('');
      
      let url = `${API_URL.CIDADES_DELETE.url}/${cidade}`;
      if (estado) {
        url += `/${estado}`;
      }
      
      const response = await api.delete(url);
      
      if (response.data) {
        const cidadeFormatada = estado ? `${cidade} (${estado})` : cidade;
        setMessage(`Cidade ${cidadeFormatada} removida com sucesso!`);
        setMessageType('success');
        
        await carregarCidades();
      } else {
        setMessage('Erro ao remover cidade');
        setMessageType('error');
      }
      
    } catch (error) {
      console.error('Erro ao remover cidade:', error);
      setMessage('Erro ao remover cidade');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cidades-container">
      <div className="cidades-header">
        <div className="header-left">
          <img src={logo} alt="Logo" className="header-logo" />
          <h1>Gerenciar Cidades</h1>
        </div>
        <button onClick={handleLogout} className="logout-button">
          Sair
        </button>
      </div>

      <div className="search-config-section">
        <h2>Configuração da busca</h2>
        <form onSubmit={salvarConfiguracao} className="search-config-form">
          <div className="search-config-grid">
            <div className="form-group">
              <label htmlFor="raioCidades">
                Raio das cidades cadastradas (km)
              </label>
              <input
                id="raioCidades"
                type="number"
                min="1"
                step="1"
                value={raioCidades}
                onChange={(e) => setRaioCidades(e.target.value)}
                disabled={configLoading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="raioGlobal">Raio global (km)</label>
              <input
                id="raioGlobal"
                type="number"
                min="1"
                step="1"
                value={raioGlobal}
                onChange={(e) => setRaioGlobal(e.target.value)}
                disabled={configLoading}
              />
            </div>
          </div>

          <label className="config-check" htmlFor="filtrarAcheSeuPintor">
            <input
              id="filtrarAcheSeuPintor"
              type="checkbox"
              checked={filtrarAcheSeuPintor}
              onChange={(e) => setFiltrarAcheSeuPintor(e.target.checked)}
              disabled={configLoading}
            />
            <span>
              <strong>Verificar “Ache Seu Pintor = 1”</strong>
              <small>Exibe somente parceiros habilitados no Ache Seu Pintor.</small>
            </span>
          </label>

          <label className="config-check" htmlFor="priorizarCluster">
            <input
              id="priorizarCluster"
              type="checkbox"
              checked={priorizarCluster}
              onChange={(e) => setPriorizarCluster(e.target.checked)}
              disabled={configLoading}
            />
            <span>
              <strong>Priorizar cluster antes da distância</strong>
              <small>
                Ordena por Diamante, Ouro, Prata e Bronze, sempre respeitando o raio.
              </small>
            </span>
          </label>

          <button
            type="submit"
            className="submit-button"
            disabled={configLoading}
          >
            {configLoading ? 'Salvando...' : 'Salvar Configuração'}
          </button>
        </form>
        {message && (
          <div className={`message ${messageType}`}>
            {message}
          </div>
        )}
      </div>

      <div className="cidades-content">
        <div className="cidades-form-section">
          <h2>Adicionar Cidades</h2>
          <p>Digite as cidades separadas por vírgula no formato "Cidade (UF)":</p>
          
          <form onSubmit={handleSubmit} className="cidades-form">
            <div className="form-group">
              <textarea
                value={cidades}
                onChange={(e) => setCidades(e.target.value)}
                placeholder="Ex: Belém (PA), Manaus (AM), Porto Velho (RO), Rio Branco (AC)"
                rows="4"
                disabled={loading}
                onFocus={limparMensagem}
              />
            </div>
            
            <button 
              type="submit" 
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'Salvando...' : 'Salvar Cidades'}
            </button>
          </form>

        </div>

        <div className="cidades-list-section">
          <h2>Cidades Cadastradas</h2>
          {loading ? (
            <div className="loading">Carregando...</div>
          ) : cidadesList.length > 0 ? (
            <div className="cidades-grid">
              {cidadesList.map((cidadeData, index) => {
                const cidadeFormatada = cidadeData.estado 
                  ? `${cidadeData.cidade} (${cidadeData.estado})` 
                  : cidadeData.cidade;
                
                return (
                  <div key={index} className="cidade-item">
                    <span className="cidade-text">{cidadeFormatada}</span>
                    <button 
                      onClick={() => removerCidade(cidadeData.cidade, cidadeData.estado)} 
                      className="remove-button"
                      title="Remover cidade"
                      disabled={loading}
                    >
                      ×
                    </button>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no-cidades">Nenhuma cidade cadastrada</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GerenciarCidades;
